<template>
  <v-list nav dense>
    <v-list :color="invalid ? 'error darken-2' : 'secondary lighten-4'" :dark="invalid" style="border-radius: .5em" class="mb-1">
      <v-list-item test-tag="tag-126">
        <v-list-item-content>
          <v-list-item-title style="font-size: 1rem !important; font-weight: 400">{{group.name}}</v-list-item-title>
          <v-list-item-subtitle><T>мин.</T>{{group.downlimit}}; <T>макс.</T>{{group.uplimit}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="invalid">
          <v-icon>mdi-alert-box-outline</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <Modifier v-for="m in group.modifiers" :key="m.id" :modifier="m" v-model="modifiers" @inc="e => $emit('inc', {...e, group})" @dec="e => $emit('dec', {...e, group})"/>
  </v-list>
</template>

<script>
import Modifier from './Modifier.vue'
export default {
  props: ['group', 'value', 'invalid'],
  computed: {
    modifiers: {
      get(){
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  components: {
    Modifier
  }
}
</script>